// بكسل فيسبوك — بالسنيبت الرسمي (من غير مكتبة react-facebook-pixel)
// أي حدث يتبعت قبل initPixel بيتحفظ في طابور وبيتبعت أول ما البكسل يجهز.

const PIXEL_ID = "4368031590128899";

let initialized = false;
let pendingPageView = false; // PageView واحد بس مهما اتنادى قبل الـ init
const pendingEvents = [];

const loadFacebookSnippet = () => {
  if (window.fbq) return;

  const n = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";

  const firstScript = document.getElementsByTagName("script")[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
};

export const initPixel = () => {
  if (initialized || typeof window === "undefined") return;

  loadFacebookSnippet();
  window.fbq("init", PIXEL_ID);
  initialized = true;

  // ابعت اللي اتأخر قبل ما البكسل يجهز
  if (pendingPageView) {
    window.fbq("track", "PageView");
    pendingPageView = false;
  }
  while (pendingEvents.length) {
    const [event, data] = pendingEvents.shift();
    window.fbq("track", event, data);
  }
};

export const pageView = () => {
  if (typeof window === "undefined") return;
  if (!initialized) {
    pendingPageView = true;
    return;
  }
  window.fbq("track", "PageView");
};

export const trackEvent = (event, data = {}) => {
  if (typeof window === "undefined") return;
  if (!initialized) {
    pendingEvents.push([event, data]);
    return;
  }
  window.fbq("track", event, data);
};